import { render, staticRenderFns } from "./IntegrationsEdit.vue?vue&type=template&id=f2c88862"
import script from "./IntegrationsEdit.vue?vue&type=script&lang=js"
export * from "./IntegrationsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports